import React, { useState, useEffect, useContext, Fragment } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import axiosService from '../../../utils/AxiosService';
import { CurrentProjectManagerContext } from '../../../contexts/CurrentProjectManagerContext';
import { ThemeContext } from '../../../contexts/ThemeContext';
import { Bell, Person } from 'react-bootstrap-icons';
import PmMenuDropdown from './PmMenuDropdown';
import ThemeToggleButton from '../../Shared/ThemeToggleButton';

export default observer(function Header() {
  const [activePath, setActivePath] = useState("")
  const [openDropdown, setOpenDropdown] = useState(false)
  let location = useLocation()
  const navigate = useNavigate()
  const { currentProjectManager, setCurrentProjectManager } = useContext(CurrentProjectManagerContext)
  const themeContext = useContext(ThemeContext)
  const themeState = themeContext?.themeState

  const paths = {
    campaigns: 'campaigns',
    potential_influencers: "potential_influencers",
    brands: "brands",
    "project-managers": "project-managers",
    influencers: "influencers",
  }

  useEffect(() => getCurrentProjectManager(), [])

  useEffect(() => updateSelectedPath(), [location.pathname])

  const navigateTo = route => (event) => {
    if (event.type === 'contextmenu') {
      event.preventDefault()
      window.open(route, '_blank')
    } else if (event.button === 1 || (event.button === 0 && event.ctrlKey)) {
      window.open(route, '_blank')
    } else {
      navigate(route)
    }
  }

  const updateSelectedPath = () => {
    const currentPath = Object.keys(paths).find(path => location.pathname.includes(path))
    setActivePath(paths[currentPath])
  }

  const getCurrentProjectManager = () => {
    axiosService.get('/api/project_manager/profile/current')
    .then(projectManager => setCurrentProjectManager(projectManager))
    .catch(() => navigate('/project_manager/login'))
  }

  return (
    <div className="fixed w-full z-20 top-0 border-b-2 border-rb-widget-border dark:border-rb-dark-mode-lighter">
      <div className="flex justify-between bg-white dark:bg-rb-dark-mode items-center p-2">
          <button
            onClick={() => navigate('/project_manager/campaigns')}
            onContextMenu={() => navigate('/project_manager/campaigns')}
          >
            <div className='flex justify-center items-center pl-2'>
              <img src="/static/reachbird_logo.png" alt="Logo" className="h-6" />
              <h1 className='pl-2 text-center align-middle text-xl font-bold dark:text-white'>Reachbird</h1>
            </div>
          </button>
        <div className="flex">
          <button className={`cursor-pointer mr-4 border-0 font-bold ${activePath === "campaigns" ? "dark:text-rb-green" : "dark:text-white"}  ${activePath === "campaigns" ? "text-rb-green" : "text-rb-black"}`}
            onClick={navigateTo('/project_manager/campaigns')}
            onContextMenu={navigateTo('/project_manager/campaigns')}
          >
            Campaigns
          </button>
          <button
            className={`cursor-pointer mr-4 border-0 font-bold ${activePath === "brands" ? "dark:text-rb-green" : "dark:text-white"}  ${activePath === "brands" ? "text-rb-green" : "text-rb-black"}`}
            onClick={navigateTo('/project_manager/brands')}
            onContextMenu={navigateTo('/project_manager/brands')}
          >
            Brands
          </button>
          <button
            className={`cursor-pointer mr-4 border-0 font-bold ${activePath === "influencers" ? "dark:text-rb-green" : "dark:text-white"} ${activePath === "influencers" ? "text-rb-green" : "text-rb-black"}`}
            onClick={navigateTo('/project_manager/influencers')}
            onContextMenu={navigateTo('/project_manager/influencers')}
          >Influencers</button>
          {currentProjectManager?.is_admin &&
            <Fragment>
              <button
                className={`cursor-pointer mr-4 border-0 font-bold ${activePath === "project-managers" ? "dark:text-rb-green" : "dark:text-white"} ${activePath === "project-managers" ? "text-rb-green" : "text-rb-black"}`}
                onClick={navigateTo('/project_manager/project-managers')}
                onContextMenu={navigateTo('/project_manager/project-managers')}
              >
                PMs
              </button>

              <button
                className={`cursor-pointer border-0 font-bold ${activePath === "potential_influencers" ? "dark:text-rb-green" : "dark:text-white"} ${activePath === "potential_influencers" ? "text-rb-green" : "text-rb-black"}`}
                onClick={navigateTo('/project_manager/potential_influencers')}
                onContextMenu={navigateTo('/project_manager/potential_influencers')}
              >
                Potential Influencers
              </button>
            </Fragment>
          }
        </div>
        <div className="flex items-center">
          <ThemeToggleButton
            className="mr-4"
            isDark={themeState?.isDark}
            onToggle={() => themeState?.toggleTheme()}
          />
          <button className="cursor-pointer flex justify-center items-center mr-4 h-9 w-9 rounded-full p-0 border-0 active:shadow-outer active:shadow-gray-400 dark:text-white"><Bell /></button>
          <button
            className="cursor-pointer flex justify-center items-center mr-2 h-9 w-9 rounded-full p-0 border-0 bg-rb-green text-white active:shadow-outer active:shadow-rb-green dark:text-rb-dark-mode"
            onClick={() => setOpenDropdown(!openDropdown)}
        >
            {currentProjectManager.avatar ? <img className="rounded-full h-9 w-9 object-cover" src={currentProjectManager.avatar.url} />: <Person />}
          </button>
        </div>
      </div>
      <PmMenuDropdown isOpen={openDropdown} setIsOpen={setOpenDropdown} currentProjectManager={currentProjectManager} />
    </div>
  )
})
